import { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";

export interface Promotion {
  label: string;
  isEnabled: boolean;
  discountPercent: number;
  startsAt: string | null;
  endsAt: string | null;
  showDuration: boolean;
  appliesTo: {
    paintingKits: boolean;
    colorPalettes: boolean;
    customOrders: boolean;
    workshops: boolean;
  };
}

interface PromotionState {
  promotion: Promotion | null;
  isActive: boolean;
  loading: boolean;
}

export function usePromotion(): PromotionState {
  const [promotion, setPromotion] = useState<Promotion | null>(null);
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPromotion = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/promotion`);
        const data = await response.json();
        setPromotion(data.promotion || null);
        setIsActive(!!data.isActive);
      } catch (error) {
        console.error("Error fetching promotion:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPromotion();
  }, []);

  return { promotion, isActive, loading };
}

export function getDiscountedPrice(
  price: number,
  discountPercent: number,
): number {
  return Math.round(price * (1 - discountPercent / 100));
}